var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drag-drop-indicator-wrap"},[_c('div',{staticClass:"drag-drop-dash drag-drop-box"},[_vm._v("Drag and drop "+_vm._s(_vm.label)+" in editor")]),_c('svg-icon',{staticClass:"drag-drop-icon",attrs:{"name":"drag","size":"md"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }